export default __webpack_public_path__ + "static/media/mentors_mv.7f9f6def.png";